import validate from 'validate.js'
import {emailConstraints, clientIdConstraints} from './fieldConstraints'
import moment from 'moment'

validate.validators.username = function(value, options){
	const validEmail = validate({email: value}, emailConstraints)
	if(validEmail){
		const validClientId = validate({clientId: value}, clientIdConstraints)
		if(validClientId){
			return options.message || '^Username is invalid'
		}else{
			return null // valid client id
		}
	}else{
		return null // valid email
	}
}

validate.validators.phoneNumber = function(value, options){
	return validate.single(value, {
		format: {
			pattern: /^(([0-9]{10})|(\+[0-9]{11})|([0-9]{8}))$/,
			message: options.message || 'Phone Number is invalid'
		}
	})
}

validate.validators.notWeekend = function(value, options){
	if([6, 7].includes(moment(value, options.format).isoWeekday())){ // Validate weekends
		return options.message || 'Date falls on a weekend'
	}
}

// https://validatejs.org/#validators-date
validate.extend(validate.validators.datetime, {
	// The value is guaranteed not to be null or undefined but otherwise it could be anything.
	parse: function(value, options){
		return +(moment.utc(value, options.format).format('x'))
	},

	// Input is a unix timestamp
	format: function(value, options){
		return moment.utc(value, 'x').format(options.format)
	}
})

validate.validators.money = function(value, options){
	const numResult = validate.validators.numericality(value, Object.assign({
		greaterThan: 0.01,
		noStrings: false,
		strict: true,
		onlyInteger: false,
		message: options.hasOwnProperty('message') ? options.message : 'must be a valid number'
	}, options))


	const formatResult = validate.validators.format(value + "", {
		pattern: /^[0-9]+(?:\.[0-9]{0,2})?$/,
		message: 'must not contain more than 2 decimals'
	})

	return numResult || formatResult
}

validate.fixForReduxForm = function(validation){
	const ret = {}
	if(validation){
		for(let [key, value] of Object.entries(validation)){
			ret[key] = Array.isArray(value) ? value[0] : value
		}
	}
	return ret
}

export default validate



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/form/validators.js